"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    counterBadgeClassNames: function() {
        return counterBadgeClassNames;
    },
    useCounterBadgeStyles_unstable: function() {
        return useCounterBadgeStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useBadgeStylesstyles = require("../Badge/useBadgeStyles.styles");
const counterBadgeClassNames = {
    root: 'fui-CounterBadge',
    icon: 'fui-CounterBadge__icon'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    dot: {
        Bf4jedk: "fgfkb25",
        a9b677: "f16dn6v3",
        Bqenvij: "f3mu39s",
        Byoj8tv: 0,
        uwmqm3: 0,
        z189sj: 0,
        z8tnut: 0,
        B0ocmuz: "f1mk8lai"
    },
    hide: {
        mc9l5x: "fjseox"
    }
}, {
    d: [
        ".fgfkb25{min-width:auto;}",
        ".f16dn6v3{width:6px;}",
        ".f3mu39s{height:6px;}",
        [
            ".f1mk8lai{padding:0;}",
            {
                p: -1
            }
        ],
        ".fjseox{display:none;}"
    ]
});
const useCounterBadgeStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(counterBadgeClassNames.root, state.dot && styles.dot, !state.root.children && !state.dot && styles.hide, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(counterBadgeClassNames.icon, state.icon.className);
    }
    return (0, _useBadgeStylesstyles.useBadgeStyles_unstable)(state);
}; //# sourceMappingURL=useCounterBadgeStyles.styles.js.map
